import React, { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "react-apollo";
import { Button, ButtonGroup, Card, Heading } from "@shopify/polaris";

// import Helper
import { baseHelper } from "lib/helpers";

// import queries
import { GET_FILTER_OPTIONS, GET_PRODUCT_METRICS } from "app/reporting/apollo/queries";

// import constant
import constant from "lib/constant/constant";

// import component
import { Spinner } from "lib/components";
import { EmptyReportingState, ReportingFilters } from "app/reporting/modules/generic/components";

// import props
import { tabProp } from "app/reporting/modules/operator/props";

// import Graph
import { BarGraph, PieGraph } from "app/reporting/modules/generic/graph";

const { MONTHS } = constant;

const ProductsTab = (props) => {
  const { reportingConfig } = props;
  const [chartType, setChartType] = useState("barChart");
  const [timePeriod, setTimePeriod] = useState();
  const [selectedDates, setSelectedDates] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filterBy, setFilterBy] = useState();
  const [selectedFilterOption, setSelectedFilterOption] = useState();
  const [graphData, setGraphData] = useState();

  const handleTimePeriod = (value) => {
    setTimePeriod(value);
    setSelectedDates(null);
  };

  const [getReporting, { loading, data: productGraphData }] = useLazyQuery(GET_PRODUCT_METRICS);
  const { data: filterResponse } = useQuery(GET_FILTER_OPTIONS);

  const filterOptionsResponse = baseHelper.getResponseData(filterResponse, constant.gql.GET_FILTER_OPTIONS) || [];

  useEffect(() => {
    const response = baseHelper.getResponseData(productGraphData, constant.gql.GET_PRODUCT_METRICS);
    if (response) {
      const productResponse = response.product.map((item) => ({ ...item, month: MONTHS[item.month - 1] }));
      setGraphData(productResponse);
    }
  }, [productGraphData]);

  useEffect(() => {
    const submitQuery = () => {
      const inputData = {
        filter: {
          days: parseInt(timePeriod, 10),
          dateRange: selectedDates,
          filterBy,
          filterOptionValue: selectedFilterOption,
        },
      };
      getReporting({
        variables: {
          input: inputData,
        },
      });
    };
    if (filterBy && selectedFilterOption && (timePeriod || selectedDates)) submitQuery();
  }, [timePeriod, selectedDates, filterBy, selectedFilterOption, getReporting]);

  const submitReportingQuery = (val) => {
    setTimePeriod(null);
    setSelectedDates(val);
  };

  return (
    <Card.Section>
      <div style={{ display: "flex", marginBottom: "15px" }}>
        <Heading>Products Metric</Heading>
        <div style={{ marginLeft: "auto" }}>
          <ButtonGroup segmented connectedTop>
            <Button size="slim" primary={chartType === "barChart"} onClick={() => setChartType("barChart")}>
              Bar chart
            </Button>
            <Button size="slim" primary={chartType === "pieChart"} onClick={() => setChartType("pieChart")}>
              Pie chart
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <ReportingFilters
        filterOptions={filterOptions}
        filterOptionsResponse={filterOptionsResponse}
        handleTimePeriod={handleTimePeriod}
        reportingConfig={reportingConfig}
        selectedFilterOption={selectedFilterOption}
        setFilterBy={setFilterBy}
        setFilterOptions={setFilterOptions}
        setSelectedDates={setSelectedDates}
        setSelectedFilterOption={setSelectedFilterOption}
        submitReportingQuery={submitReportingQuery}
        timePeriod={timePeriod}
      />
      {loading && (
        <div style={{ top: "60%", "min-height": "500px" }}>
          <Spinner />
        </div>
      )}
      {!loading && graphData?.length > 0 && chartType === "barChart" && (
        <BarGraph data={graphData} xDataKey="month" barDataKey="count" />
      )}
      {!loading && graphData?.length > 0 && chartType === "pieChart" && (
        <PieGraph data={graphData} labelSuffix="month" dataKey="count" />
      )}
      {!loading && !graphData?.length && <EmptyReportingState />}
    </Card.Section>
  );
};

ProductsTab.propTypes = tabProp.type;

export default ProductsTab;
